<div class="row">
  <div class="col-xs-8">
    <div class="progress progress_sm">
      <div class="progress-bar {{color}}" role="progressbar" data-transitiongoal="rate" [style.width]="rate + '%'"></div>
    </div>
  </div>
  <div class="col-xs-2 more_info"><span>{{ rate | number: '1.0-2' }}%</span></div>
</div>
